import React from 'react';

import Carousel from 'src/components/Carousel';
import VerticalSkeletonLoader from 'src/components/thumbnail/thumbnailTypes/Vertical/VerticalSkeletonLoader';

import * as customStyled from './styles';
import {
  mapBreakPointsWithTagsForRails,
  RailsSkeletonCount
} from '../rails/railsHelper';

interface SkeletonSimilarContentTrayProps {
  railCount?: number;
}

const SkeletonSimilarContentTray: React.FC<SkeletonSimilarContentTrayProps> = ({
  railCount
}) => {
  const renderRails = () => {
    const rails = new Array(railCount || RailsSkeletonCount.TWO).fill(
      'skeletonRail'
    );
    const thumbnails = new Array(8).fill('skeletonThumbnail');
    return rails.map((item, index) => {
      return (
        <div key={item + index} css={customStyled.skeletonRailsContainer}>
          <div css={customStyled.skeletonRailsHeaderStyle}></div>
          <Carousel
            breakPointsConfig={mapBreakPointsWithTagsForRails?.vertical}>
            {thumbnails.map((thumbnailItem, thumbnailIndex) => (
              <VerticalSkeletonLoader
                key={thumbnailItem + thumbnailIndex}
                type="similarContent"
              />
            ))}
          </Carousel>
        </div>
      );
    });
  };
  return <div>{renderRails()}</div>;
};

export default React.memo(SkeletonSimilarContentTray);
